// ############################################################
// show mail icon again once user clicks outside newsletter input and input is empty
const newsletterInput = document.getElementsByClassName('footer__newsletter-input');
if(newsletterInput.length > 0 && newsletterInput[0].hasAttribute('id') && newsletterInput[0].getAttribute('id').startsWith('Email-newsletter_')) {
    newsletterInput[0].addEventListener('blur', (event) => {
        if(event.target.value.length === 0)
            event.target.classList.remove('footer__newsletter-input--active');
    });
    newsletterInput[0].addEventListener('focus', (event) => {
        if(event.target.value.length > 0)
            event.target.classList.add('footer__newsletter-input--active');
        else event.target.classList.remove('footer__newsletter-input--active');
    });
}
// ############################################################

initZakekeAddToCartForm(window.zakekeTranslatedProduct);
async function zakekeAddToCart(context) {
    console.log('ZAKEKE POST BEFORE');
    const form = document.getElementById('zakeke-addtocart');
    button = form.querySelector('[type="submit"]');
    button.click();
    console.log('ZAKEKE POST');
}
function initZakekeAddToCartForm(product) {
    const zakekeForm = document.getElementById('zakeke-addtocart');
    if(zakekeForm && zakekeForm.length > 0) {
        console.log('USE ZAKEKE FORM');
        idInput = zakekeForm.querySelector('[name="id"]');
        idInput.value = product.variants[0].id;

        quantityInput = zakekeForm.querySelector('[name="quantity"]');
        quantityInput.value = 1;

        formTypeInput = document.createElement('input');
        formTypeInput.setAttribute('type', "hidden");
        formTypeInput.setAttribute('name', "form_type");
        formTypeInput.value = "product";
        zakekeForm.append(formTypeInput);

        utf8Input = document.createElement('input');
        utf8Input.setAttribute('type', "hidden");
        utf8Input.setAttribute('name', "utf8");
        utf8Input.value = "✓";
        zakekeForm.append(utf8Input);

        productIdInput = document.createElement('input');
        productIdInput.setAttribute('type', "hidden");
        productIdInput.setAttribute('name', "product-id");
        productIdInput.value = product.id;
        zakekeForm.append(productIdInput);

        sectionIdInput = document.createElement('input');
        sectionIdInput.setAttribute('type', "hidden");
        sectionIdInput.setAttribute('name', "section-id");
        sectionIdInput.value = "template--"+idInput.value+"__main";
        zakekeForm.append(sectionIdInput);

        sectionsInput = document.createElement('input');
        sectionsInput.setAttribute('type', "hidden");
        sectionsInput.setAttribute('name', "sections");
        sectionsInput.value = "sections--"+idInput.value+"__header_section";
        zakekeForm.append(sectionsInput);

        submitButton = document.createElement('input');
        submitButton.setAttribute('type', "submit");
        submitButton.setAttribute('name', "btn-submit");
        submitButton.value = "Absenden";
        zakekeForm.append(submitButton);
    }
}

// ############################################################
function fireCartStatistics(payload) {
  // Extract variant/quantity if available
  const variantId = payload.variantId || payload.product_variant_id;
  const quantity = payload.quantity || 1;

  // Trigger Shopify Analytics event
  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("cart_add", {
      product_variant_id: variantId,
      quantity: quantity
    });
  }

  console.log("Shopify cart_add fired");
} 
// ############################################################

// ############################################################

const MAX_ITERATIONS = 100;
document.addEventListener('DOMContentLoaded', event => {
    if (isZakekeConfiguratorPage()){
        waitUntilIframeIsAvailable(0);
    }
    if (window.location.href.includes("/cart")) {
        initCartPreviewImageLayout()
    }
});

let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (isZakekeConfiguratorPage()) {
            waitUntilIframeIsAvailable(0);
        }
    }, 200); // wait 200ms after resizing stops
});


function isZakekeConfiguratorPage(){
    if (window.location.href.includes("/apps/zakeke")) {
        return true;
    }
    return false;
}

function initCartPreviewImageLayout(){
    const cartItems = document.querySelectorAll('.cart__item');
    cartItems.forEach(item => {
        const cartItemSub = item.querySelector('.cart__item-sub > div');
        if(cartItemSub.children.length < 3){
            //zakeke preview is missing => add original image
            const originalImage = item.querySelector('.cart__image');
            originalImage.classList.add('default-preview-image');
            const previewNode = document.createElement('div');
            previewNode.style.display = 'flex';
            previewNode.append(originalImage);
            cartItemSub.insertBefore(previewNode, cartItemSub.children[1]);
        }
    });
}


async function waitUntilIframeIsAvailable(iteration = 0){
    if(iteration > MAX_ITERATIONS){
        return;
    }
    const iframe = document.querySelector('body div#zakeke-container');
    if(iframe){
        document.querySelector('body').classList.add('w-cfg');
        observeIframeSize(iframe);
    } else {
         await new Promise(resolve => setTimeout(resolve, 300));
         iteration+=1;
         return waitUntilIframeIsAvailable(iteration);
    }
}

async function waitUntilElementIsAvailable(iteration = 0, elementQuerySelector){
    if(iteration > MAX_ITERATIONS){
        return;
    }
    const element = document.querySelector(elementQuerySelector);
    if(element){
        return element;
    } else {
        await new Promise(resolve => setTimeout(resolve, 300));
        iteration+=1;
        return waitUntilElementIsAvailable(iteration,elementQuerySelector);
    }
}
//--------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------
async function observeIframeSize(iframe) {

    const floatingBtn = await waitUntilElementIsAvailable(0, '#Sea-Accessibility__ButtonWidget');

    const observer = new IntersectionObserver(entries => {
        const entry = entries[0];

        if (entry.isIntersecting) {
            if(window.innerWidth < 769){
                floatingBtn.style.top = '';
                return;
            }
            const iframeTop = entry.boundingClientRect.top;
            const iframeHeight = iframe.offsetHeight;

            // Distance from bottom of viewport to the top of iframe
            const distanceFromBottom = iframeTop + iframeHeight;

            // Move button so it sits 130px above iframe
            floatingBtn.style.bottom = 'unset';
            floatingBtn.style.top = `${distanceFromBottom - 190}px`;
        } else {
            // Iframe not in view → reset button to default
            floatingBtn.style.bottom = "20px";
        }
    }, {threshold: 0});

    if (floatingBtn) {
        observer.observe(iframe);
    } else {
        //console.log('no ele to observe');
    }
}
//--------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------
//--------------------------------------------------------------------------------------

// ############################################################
// Prevent Zakeke Plugin scrolling in background
/*(function ScrollLockManager() {
  const container = document.getElementById('zakeke-container');
  if (!container) return;

  let scrollTop = 0;

  function lockScroll() {
    scrollTop = window.scrollY || document.documentElement.scrollTop;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollTop}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    document.body.classList.add('scroll-locked');
    document.documentElement.classList.add('scroll-locked');
  }

  function unlockScroll() {
    document.body.classList.remove('scroll-locked');
    document.documentElement.classList.remove('scroll-locked');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';

    window.scrollTo(0, scrollTop);
  }

  function isVisible(el) {
    const style = window.getComputedStyle(el);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      el.offsetHeight > 0 &&
      el.offsetParent !== null
    );
  }

  let lastState = null;

  function checkVisibility() {
    const currentState = isVisible(container);
    if (currentState !== lastState) {
      lastState = currentState;
      currentState ? lockScroll() : unlockScroll();
    }
  }

  checkVisibility();

  const observer = new MutationObserver(checkVisibility);
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  window.addEventListener('resize', checkVisibility);
})();*/
// ############################################################

// ############################################################
// Integrate shop pay wallet buttons faster
document.addEventListener('DOMContentLoaded', () => {
    const walletButton = document.querySelector('shop-pay-wallet-button');
    if (walletButton) {
        walletButton.setAttribute('data-loaded', 'true'); // Trigger for Theme-Logic
    }
});
// ############################################################
document.addEventListener('DOMContentLoaded', function () {
    const parents = document.querySelectorAll('.site-nav.site-navigation.small--hide > li.site-nav--has-dropdown');
    parents.forEach(link => {
        let touched = false;
        link.addEventListener('touchstart', function (e) {
            if (!touched) {
                if(!this.classList.contains('submenu-open')){
                    touched = true;
                    e.preventDefault();         // prevent navigation
                    parents.forEach(d => {
                        d.classList.remove('submenu-open');
                        d.querySelector('details')?.removeAttribute('open');
                    })
                    this.classList.add('submenu-open');
                    link.querySelector('details').setAttribute('open', '');

                    // reset so next tap navigates
                    setTimeout(() => {touched = false;}, 0);
                }
            } else {
                // second tap → allow navigation
                touched = false;
            }
        }, { passive: false });
    });
});
// ############################################################
